/** Must stay in sync with `views/layouts/_partials/_termsOfServicePopup.php`. */
export const PHP_LAYOUT_TOS_POPUP_MODAL_ID = 'acceptTermsOfServiceModal';
export const PHP_LAYOUT_TOS_POPUP_ERROR_ELEMENT_ID = 'acceptTermsOfServiceError';
export const PHP_LAYOUT_TOS_POPUP_ACCEPT_BUTTON_ID = 'acceptTermsOfServiceBtn';
